import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { Attention } from 'legacy/lut/components/widgets/public/partner360/composedReport/components/filterArea/filterButtons/saveFilterAreaModal/components/attention/Attention'
import { TSaveMethod } from 'legacy/lut/components/widgets/public/partner360/composedReport/components/filterArea/filterButtons/saveFilterAreaModal/models'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { updateOpenedFilterData } from 'legacy/lut/features/partner360/composedReport'
import { selectFilterForSave } from 'legacy/lut/features/partner360/composedReport/selectors/selectFilterForSave'
import { selectOpenedFilterData } from 'legacy/lut/features/partner360/composedReport/selectors/selectOpenedFilterData'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { Input } from 'legacy/lut/library/inputs'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import { Loader } from 'core-components/library/loader'

import { saveFilter } from '../api/saveFilter'

import styles from './SaveFilterAreaModalContent.module.scss'

interface IProps {
  onClose: () => void
}

export const SaveFilterAreaModalContent = ({ onClose }: IProps) => {
  const [loaded, setLoaded] = useState(false)
  const [filterName, setFilterName] = useState('')
  const [methodForSave, setMethodForSave] = useState<TSaveMethod>('create')
  const openedFilterData = useSelector(selectOpenedFilterData)
  const filterForSave = useSelector(selectFilterForSave)

  const dispatch = useAppDispatch()

  const saveButtonText = useMemo(() => {
    return methodForSave === 'create'
      ? TRANSLATION_KEYS.savedFiltersDialogSave
      : TRANSLATION_KEYS.savedFiltersDialogUpdate
  }, [methodForSave])

  useEffect(() => {
    if (openedFilterData) {
      setFilterName(openedFilterData.Name)
      setMethodForSave('update')
    }
  }, [openedFilterData?.Name])

  const changeMethodForSave = useCallback((value: boolean) => {
    value ? setMethodForSave('create') : setMethodForSave('update')
  }, [])

  const handleAddNew = useCallback(async () => {
    setLoaded(true)
    const data = await saveFilter({
      EntryId: openedFilterData?.EntryId,
      Name: filterName,
      Filters: JSON.stringify(filterForSave),
      method: methodForSave,
    })

    if (data[0].EntryId) {
      dispatch(updateOpenedFilterData({ EntryId: data[0].EntryId, Name: filterName }))
    }

    setLoaded(false)
    onClose()
  }, [filterName, filterForSave, onClose, methodForSave, dispatch])

  if (loaded) {
    return <Loader />
  }

  return (
    <>
      <div>
        <WidgetHeader>{TRANSLATION_KEYS.savedFiltersDialogHeader}</WidgetHeader>
        <div>
          <RenderWhen condition={Boolean(openedFilterData?.EntryId)}>
            <Attention translation={TRANSLATION_KEYS.saveFilterAttention} />
            <Checkbox
              disabled={filterName === openedFilterData?.Name}
              margin={'md'}
              label={<Translation text={TRANSLATION_KEYS.saveFilterCheckbox} />}
              onChange={changeMethodForSave}
              checked={methodForSave === 'create'}
            />
          </RenderWhen>

          <Input value={filterName} label={'Filter Name'} onChange={setFilterName} />
          <div className={styles.btns}>
            <Button className={styles.btn} onClick={handleAddNew}>
              <Translation text={saveButtonText} />
            </Button>
            <Button color={'grey'} className={styles.btn} onClick={onClose}>
              <Translation text={TRANSLATION_KEYS.savedFiltersDialogCancel} />
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
